// eslint-disable-next-line no-await-in-loop
// eslint-disable-next-line no-await-in-loop
import { metadata, studies as ohifStudies, utils } from '@ohif/core';
import OHIFDicomPDFSopClassHandler from './OHIFDicomPDFSopClassHandler';

import searchStudies from '../studyLobby/searchStudies';

import store from '../store/store';
import { setFetchedStudies, addStudy, setPatient } from '../actions/PatientActions';
import { getHeadersConfig } from './getHeadersConfig';
import axios from 'axios';

export const getCurrentStudy = (patient) => {
  const config = store.getState().config;
  // estudio entero.
  let selectedStudy = patient && patient.studies && patient.studies.filter((study) => study.StudyInstanceUID === patient.mainStudyId);

  // historial, sacar estudio
  if (selectedStudy.length < 1 && config.WITH_PATIENT_HISTORY) selectedStudy = patient.patientHistory.filter((study) => study.StudyInstanceUID === patient.mainStudyId);

  // const await getStudyById(patient.mainStudyId);

  return (selectedStudy && selectedStudy[0]) || patient.studies[0];
};

export const parsePatientFromStudy = (study) => {
  const patient = store.getState().patient; // llamando al paciente todo el tiempo?
  const { WITH_PATIENT_DISCLOSED } = store.getState().config;

  patient.PatientID = (patient.PatientID && patient.PatientID) || study.PatientID;

  if (WITH_PATIENT_DISCLOSED) {
    patient.PatientName = (patient.PatientName && patient.PatientName) || study.PatientName;
    patient.PatientAge = (patient.PatientAge && patient.PatientAge) || study.PatientAge;
    patient.PatientWeight = (patient.PatientWeight && patient.PatientWeight) || study.PatientWeight;
    patient.PatientBirthDate = (patient.PatientBirthDate && patient.PatientBirthDate) || study.PatientBirthDate;
    patient.PatientSex = (patient.PatientSex && patient.PatientSex) || study.PatientSex; // still small caps
    patient.ReferringPhysicianName = (patient.ReferringPhysicianName && patient.ReferringPhysicianName) || study.ReferringPhysicianName;
  }
  return patient;
};

const addSeriesToStudy = (studyMetadata, series, server) => {
  const study = studyMetadata.getData();
  const servers = Array.isArray(study.servers)
    ? study.servers
    : [study.servers || server];
  const seriesMetadata = new metadata.OHIFSeriesMetadata(series, study);
  const existingSeries = studyMetadata.getSeriesByUID(series.SeriesInstanceUID);
  if (existingSeries) {
    studyMetadata.updateSeries(series.SeriesInstanceUID, seriesMetadata);
  } else {
    studyMetadata.addSeries(seriesMetadata);
  }

  try {
    studyMetadata.createAndAddDisplaySetsForSeries(OHIFDicomPDFSopClassHandler, seriesMetadata);
  } catch (error) {
    console.error(error);
  }

  study.displaySets = studyMetadata.getDisplaySets();
  updateStudyMetadataManager(study, studyMetadata);
  store.dispatch(addStudy({ ...study, servers }));
};

export const loadNextSeriesOhifMetadata = (study, server) => {

  const OHIFStudyMetadata = new metadata.OHIFStudyMetadata(study, study.StudyInstanceUID);

  updateStudyDisplaySets(study, OHIFStudyMetadata);
  updateStudyMetadataManager(study, OHIFStudyMetadata);

  const studyMetadataWithServer = { OHIFStudyMetadata, server };

  return loadRemainingSeries(studyMetadataWithServer);
};

/**
 *
 * @param metadata
 * @returns {Promise<Awaited<undefined|*>[]>}
 */
export const loadRemainingSeries = async (metadata) => {
  const studyMetadata = metadata.OHIFStudyMetadata;
  const servers = metadata.server;
  const { seriesLoader } = studyMetadata.getData();

  if (!seriesLoader) {
    return;
  }
  const loadNextSeries = async () => {
    if (!seriesLoader.hasNext()) {
      return;
    }
    const series = await seriesLoader.next();
    if (series) {
      addSeriesToStudy(studyMetadata, series, servers);
      return loadNextSeries();
    }
  };
  // Start one asynchronous metadata request per series. The caller does not
  // await this aggregate Promise, so each series is added as its own request
  // resolves without blocking the viewer startup.
  const concurrentRequestsAllowed = studyMetadata.getSeriesCount();
  const promises = Array(concurrentRequestsAllowed)
    .fill(null)
    .map(loadNextSeries);
  return await Promise.all(promises);
};

export const checkServerAndStudyPromise = async ({server, studyInstanceUID, accessionNumberToFetch, timeout = 5000}) => {
  const config = store.getState().config;
  const headersConfig = getHeadersConfig(config.authorizationHeader);
  const searchQuery = accessionNumberToFetch ? 'AccessionNumber=' + accessionNumberToFetch : 'StudyInstanceUID=' + studyInstanceUID
  const checkUrl = server.qidoRoot + '/studies?limit=1&' + searchQuery;
  try {
    const axiosResponse = await axios.get(checkUrl, {...headersConfig, timeout});
    return (axiosResponse.status === 200)
  } catch(e) {
    console.error('error searching study:', e);
    return false;
  }
};

export const getStudyOfAvailableServer = async (servers, studyInstanceUID) => {
  let study;
  let studies = [];
  for (const server of servers) {
    const isStudyInServer = await checkServerAndStudyPromise({server, studyInstanceUID, timeout: 10000});
    if (isStudyInServer) {
      try{
        study = await ohifStudies.retrieveStudyMetadata(server, studyInstanceUID).then((res) => res);
        loadNextSeriesOhifMetadata(study, server).catch((loadError) => {
          console.error('Unable to load the remaining study metadata.', loadError);
        });
        console.info(`Downloading study from endpoint ${server.qidoRoot}:`, studyInstanceUID);
        studies.push(study);
      } catch (err) {
        console.error(`Error on study download from endpoint ${server.qidoRoot}:`, err);
        continue;
      }
    }
  }
  if (study) {
    const series = studies.map(study => study.series);
    const seriesConcat = [].concat(...series);
    const mergedSeries = removeDuplicateSeries(seriesConcat);
    const seriesMap = {};
    mergedSeries.forEach(serie => {
      seriesMap[serie.SeriesInstanceUID] = serie;
    });
    study.series = mergedSeries;
    study.seriesMap = seriesMap;
  }

  return study;
};

export const getStudyById = async (studyInstanceUID, servers) => {
  const study = await getStudyOfAvailableServer(servers, studyInstanceUID);

  return { ...study, servers };
};

export const updateStudyDisplaySets = (study, studyMetadata) => {
  if (!study.displaySets) {
    study.displaySets = studyMetadata.createDisplaySets(OHIFDicomPDFSopClassHandler);
  }
};

export const updateStudyMetadataManager = (study, studyMetadata) => {
  const { StudyInstanceUID } = study;
  if (!utils.studyMetadataManager.get(StudyInstanceUID)) {
    utils.studyMetadataManager.add(studyMetadata);
  }
};

const filterStudyObject = (study) => (({ StudyInstanceUID, AccessionNumber, StudyDescription, StudyDate, NumberOfStudyRelatedSeries, NumberOfStudyRelatedInstances, modalities, StudyTime }) => ({
    StudyInstanceUID,
    AccessionNumber,
    StudyDate,
    StudyTime,
    NumberOfStudyRelatedSeries,
    NumberOfStudyRelatedInstances,
    StudyDescription,
    modalities,
}))(study);

export const fetchAllPatientMetadata = async (PatientID, availableServers) => {
  if (!PatientID) return {};

  const config = store.getState().config;

  // get patient history studies (study objects with few properties)
  if (config.WITH_PATIENT_HISTORY) {
    for (let i = 0; i < availableServers.length; i++) {
      let server = availableServers[i];
      try {
        searchStudies(server, { PatientID })
          .then(async result => {

            // Fill Patient data additional fields taken from studies.searchStudies and dispatch it
            const patient = parsePatientFromStudy(result[0]);
            store.dispatch(setPatient(patient));

            // For each light Study, filter the necessary fields and dispatch them to 'fetched studies'
            const filtered = result.map((study) => ({ ...filterStudyObject(study), servers: availableServers }));
            store.dispatch(setFetchedStudies(filtered));
          });
      } catch (err) {
        console.error('can not find patient history at: ', availableServers[i].qidoRoot);
      }
    }
  }
};

export const removeDuplicateSeries = (mergedSeries) => {
  let a = mergedSeries;
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i].SeriesInstanceUID === a[j].SeriesInstanceUID) {
        a.splice(j--, 1);
      }
    }
  }

  return a;
};

export const findStudySeries = ({ study, SeriesInstanceUID }) => {
  const seriesMap = typeof study.seriesMap.get === 'function'
    ? study.seriesMap.get(SeriesInstanceUID)
    : study.seriesMap[SeriesInstanceUID];

  return seriesMap && {
    ...seriesMap,
    SeriesInstanceUID: seriesMap.SeriesInstanceUID.replace(/:\w+$/, ''),
  };
};
